import { Hidden }                   from "@material-ui/core";
import * as React                   from "react";
import { FC }                       from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card }                     from "semantic-ui-react";
import Account                      from "../../../../domain/account/Account";
import AccountRoleType              from "../../../../domain/account/AccountRoleType";
import { ResKaState }               from "../../../../index";
import RouterDispatcher             from "../../../../infrastructure/redux/router/RouterDispatcher";

const EmailSendSettingButton: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  switch (account.role.value) {
    default:
      return null;
    case AccountRoleType.CORPORATION:
    case AccountRoleType.OFFICE:
    case AccountRoleType.STAFF:
      return (
        <>
          <Hidden smDown={ true }>
            <Card onClick={ () => routerDispatcher.mailSetting() }>
              <Card.Content>
                <Card.Header>メール配信の設定をする</Card.Header>
                <Card.Description>
                  メールの共通な文面やメールのフッター、配信先のグループを作成することができます。
                </Card.Description>
              </Card.Content>
            </Card>
          </Hidden>

          <Hidden mdUp={ true }>
            <Card onClick={ () => routerDispatcher.mailSetting() }>
              <Card.Content>
                <Card.Header>メール配信の設定をする</Card.Header>
              </Card.Content>
            </Card>
          </Hidden>
        </>
      );
  }
};

export default EmailSendSettingButton;
